import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';
import {ConventionCenterService} from '../../../services/convention-center.service';
import {ConventionCenter} from '../../../models/convention-center';
import {SnackBarIconService} from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {ConventionRoomDialogComponent} from '../convention-room-dialog/convention-room-dialog.component';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-convention-center-dialog',
  templateUrl: './convention-center-dialog.component.html',
  styleUrls: [ './convention-center-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class ConventionCenterDialogComponent implements OnInit {

  //public Editor = ClassicEditor;
  public local_title: string;
  public isEdit: boolean; // is insert or update

  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form

  public spinner: boolean = false;

  public rooms: any[] = [];

  public dataSource: MatTableDataSource<any>
  public displayedRoomColumns: string[] = [ 'name', 'edit', 'delete' ];
  constructor (
    private fb: FormBuilder,
    private dialog: MatDialog,
    private _conventionCenterService: ConventionCenterService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: ConventionCenter
  ) {
   // console.log('this.data: ' + JSON.stringify(this.data))
  }


  ngOnInit () {

    this._adapter.setLocale('pt');

    // check is is insert or update
    if (this.data.id != "0") {
      this.isEdit = true;
      this.local_title = this.data.name
    } else {
      this.isEdit = false
      this.local_title = "Novo Local"
    }

    this.entityForm = this.createForm()
    this.setFormValues(this.data, this.entityForm)

  }

  insert () {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: ConventionCenter = this.createEntity(this.entityForm.value);

      this._conventionCenterService.insert(entity)
        .then((result) => {
          this.data.id = entity.id
          this.isEdit = true;
          this.entityForm.controls.id.setValue(entity.id);
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("insert regional error: " + error)
          this.snackBar.openSnackBar("Erro", '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }

  }

  update () {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: ConventionCenter = this.createEntity(this.entityForm.value);

      this._conventionCenterService.update(entity)
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("convention center update error: " + JSON.stringify(error))
          this.snackBar.openSnackBar('Erro', '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }
  }

  createEntity (data: any): ConventionCenter {
    let entity = new ConventionCenter();
    entity.id = data.id;
    entity.name = data.name;
    entity.city = data.city;
    entity.state = data.state;
    entity.address = data.address;

    entity.rooms = this.rooms || [];

    return entity;
  }

  setFormValues (data, form) {
    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    form.controls.city.setValue(data.city);
    form.controls.state.setValue(data.state);
    form.controls.address.setValue(data.address);

    this.rooms = this.data.rooms;
    this.dataSource = new MatTableDataSource(this.rooms);

  }

  createForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      city: new FormControl('', [ Validators.required ]),
      state: new FormControl('', [ Validators.required ]),
      address: new FormControl('', [ Validators.required ])
    });
    return form
  }

  openRoomDialog (entity) {

    let data: any = {}

    if (entity) {
      data = entity;
    } else {
      data.id = '0'
    }

    let dialogRef = this.dialog.open(ConventionRoomDialogComponent, {
      width: '400px',
      height: '300px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed().subscribe(response => {

      if (!response) {
        return;
      }

      const action: string = response[ 0 ];
      const formData: FormGroup = response[ 1 ];
      const data = formData.getRawValue()

      let room: any
      if (action === 'add') {
        const room_id = new Date().getTime().toString()
        room = {id: room_id, name: data.name}
        this.rooms.push(room)
        

      } else {

        let _room = this.rooms.find((e) => {
          return e.id === data.id
        })
        _room.name = data.name
      }

      this.dataSource = new MatTableDataSource(this.rooms);

    })

  }

  deleteRoom(element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.name + "<br><br>Excluir esta Sala/Auditório?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this.rooms = this.rooms.filter((e)=>{
          return e.id !== element.id
        })

        this.dataSource = new MatTableDataSource(this.rooms);
      }
    })
  }

}



